export default __webpack_public_path__ + "static/media/forward.96e4f8ad.svg";